import { CHARACTER_WHITESPACE } from '../../../../../constants/common'
import {
  formatCalendarDate,
  getCalendarOwnDayLoad,
} from '../../../Calendar.utils'

export function getCalendarViewRelieveDayNextFreeDay({ data, date, user }) {
  return {
    date: getCalendarOwnDayLoad({ data, date, user })?.next_free_date ?? null,
    isFailed: false,
  }
}

export function getCalendarViewRelieveDayCapText({ advisory, locale, t }) {
  const lines = advisory.per_user
    .filter(load => load.is_full)
    .map(load =>
      t('Calendar.CapWarningMassKey', {
        count: load.written_count,
        date: formatCalendarDate({ date: advisory.date, locale }),
        limit: advisory.limit,
        used: load.follow_up_count,
        user: load.name,
      })
    )

  return lines.length > 0 ? lines.join(CHARACTER_WHITESPACE) : null
}
